import { useQuery } from '@tanstack/react-query';

import { queryKeys } from './use-data';

import { dataService } from '@/services/data-service';

/**
 * Work-order counts by status, for the v2 dashboard tiles and donut (#279).
 *
 * One request rather than one per status — see `GET /work-orders/stats` for why. Keyed by
 * the PM scope so a property manager's numbers and an admin's are cached separately instead
 * of overwriting each other.
 */
export function useWorkOrderStats(associationPmId?: string) {
	return useQuery({
		queryKey: [...queryKeys.workOrders.all, 'stats', associationPmId ?? 'all'],
		queryFn: () => dataService.getWorkOrderStats({ associationPmId }),
	});
}
